import { render, staticRenderFns } from "./RequisitionCreation.vue?vue&type=template&id=70c9c234&scoped=true&"
import script from "./RequisitionCreation.vue?vue&type=script&lang=js&"
export * from "./RequisitionCreation.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionCreation.vue?vue&type=style&index=0&id=70c9c234&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9c234",
  null
  
)

export default component.exports